import { render, staticRenderFns } from "./LeadCategoryManager.vue?vue&type=template&id=68b1029e&scoped=true&"
import script from "./LeadCategoryManager.vue?vue&type=script&lang=js&"
export * from "./LeadCategoryManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1029e",
  null
  
)

export default component.exports